import { useTranslate } from '@tolgee/react';
import React, { FC, useEffect, useState } from 'react';
import { Button, Form, OverlayTrigger, Popover } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe } from '@fortawesome/pro-duotone-svg-icons';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import * as locales from 'react-date-range/dist/locale';
import { Calendar } from 'react-date-range';
import { addDays } from 'date-fns';
import TimeField from 'react-simple-timefield';
import {
  PLATFORM_COLORS,
  PLATFORM_DISPLAY_NAME_KEYS,
  PLATFORM_DISPLAY_NAME_KEYS_WITH_ALL,
  PLATFORM_ICONS
} from '../../../../../config/icons';
import { getLanguage } from '../../../../../locales/language';
import { useDispatch, useSelector } from 'react-redux';
import {
  addPublicationDate,
  addPublicationDateTime,
  addPublicationTime,
  clearPublicationDateTime
} from '../../../../../redux/slices/lomavisCreator/lomavisCreator';
import { lomavisCreatorRootState } from '../../../../../pages/lomavisCreator';
import moment from 'moment-timezone';
import { TimeSelect } from '../../sharedComponents';
import { getDateTimeFormated } from '../../../../utils/dates/utils';

interface Props {
  platform: any;
  currentPlatform: string;
  setCurrentPlatform: React.Dispatch<React.SetStateAction<string>>;
}

const PublicationDateTimeBox: FC<Props> = ({
  platform,
  currentPlatform,
  setCurrentPlatform
}) => {
  const { t } = useTranslate();
  const dispatch = useDispatch();

  const [hour, setHour] = useState<number>(12);
  const [minute, setMinute] = useState<number>(15);
  const postData = useSelector(
    (state: lomavisCreatorRootState) => state.lomavisCreator.postData[platform]
  );

  const timeZone = useSelector(
    (state: lomavisCreatorRootState) => state.lomavisCreator.timeZone
  );

  const [currentTimeInput, setCurrentTimeInput] = useState(false);
  const [time, setTime] = useState('');

  const [toggleDate, setToggleDate] = useState(false);

  const [date, setDate] = useState(null);

  const onDateChange = async (item: any) => {
    dispatch(
      addPublicationDate({
        platform,
        date: item
      })
    );
  };

  const popover = () => {
    return (
      <Popover
        style={{
          width: '100%',
          maxWidth: '370px',
          overflow: 'auto'
        }}
        id="popover-basic "
      >
        <Popover.Body style={{ width: '100%' }}>
          <div
            style={{
              display: 'flex',
              flexFlow: 'column nowrap',
              width: '100%',
              zIndex: 10
            }}
          >
            <div className="w-100 d-flex justify-content-end">
              <i
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  setCurrentPlatform(null);
                }}
                className="fa-duotone fa-solid fa-xmark-large cursor-pointer"
              ></i>
            </div>
            <Calendar
              onChange={async (item) => {
                onDateChange(item);
                setCurrentTimeInput(true);
                setDate(item);
                setCurrentPlatform(null);
              }}
              minDate={new Date()}
              maxDate={new Date(new Date().getFullYear() + 1, 12, 31)}
              locale={locales[getLanguage()]}
              date={
                postData.tempPublicationData?.date
                  ? new Date(postData.tempPublicationData?.date)
                  : new Date()
              }
              className="w-100"
            />
          </div>
        </Popover.Body>
      </Popover>
    );
  };

  const getOneHourFromNow = () => {
    const currentTime = new Date();
    const oneHourLater = new Date(currentTime.getTime() + 60 * 60 * 1000);

    // Extract hours and minutes
    const hours = oneHourLater.getHours().toString().padStart(2, '0');
    const minutes = oneHourLater.getMinutes().toString().padStart(2, '0');

    // Construct formatted time string
    const formattedTime = `${hours}:${minutes}`;

    return formattedTime;
  };

  const convertDateTime = () => {
    const date = moment(postData.tempPublicationData.date).format('YYYY-MM-DD');
  const time = postData.tempPublicationData.time; 
  const [hour, minute] = time.split(':').map(n => n.padStart(2, '0'));
  const timeFormatted = `${hour}:${minute}`;

  const dateTime = moment.tz(`${date} ${timeFormatted}`, 'YYYY-MM-DD HH:mm', timeZone);


    const convertedDateTime = dateTime.format(); 
    console.log('Converted DateTime:', convertedDateTime);

    dispatch(
      addPublicationDateTime({
        platform,
        dateTime: convertedDateTime
      })
    );
  };
  

  useEffect(() => {
    if (
      postData.tempPublicationData.time &&
      postData.tempPublicationData.date
    ) {
      convertDateTime();
    }
  }, [postData.tempPublicationData.time, postData.tempPublicationData.date]);
  const handleTimeChange = (hour: number, minute: number) => {
    const value = `${hour}:${minute}`;
    dispatch(
      addPublicationTime({
        platform,
        time: value
      })
    );
    () => setTime(value);
  };

  useEffect(() => {
    const [inputHour, inputMinute] = postData.tempPublicationData?.time
      ?.split(':')
      .map(Number);
    console.log('inputHour', inputHour);
    console.log('inputMinute', inputMinute);
    console.log("tempPublicationData", postData.tempPublicationData);
    setHour(inputHour);
    setMinute(inputMinute);
  }, [postData.tempPublicationData?.time]);

  return (
    <div className="d-flex flex-column gap-2 my-1">
      <div className="d-flex justify-content-start gap-2 align-items-center">
        <div className={'d-flex flex-row mb-1'}>
          <span className={'me-2'}>
            <i
              className={PLATFORM_ICONS[platform]}
              style={{ color: PLATFORM_COLORS[platform], fontSize: '20px' }}
            ></i>{' '}
          </span>
          <span className={'fw-bold text-dark'}>
            {t(PLATFORM_DISPLAY_NAME_KEYS_WITH_ALL[platform])}
          </span>
        </div>
      </div>
      <div className="d-flex flex-column gap-1">
        <div className="d-flex w-100 justify-content-between gap-2">
          <div style={{ width: '60%' }} className="d-flex flex-column">
            <label htmlFor="dateInput">{t('date')}</label>

            <OverlayTrigger
              trigger="click"
              placement="auto"
              show={currentPlatform === platform}
              onToggle={() => {
                setCurrentPlatform((prev) =>
                  prev === platform ? null : platform
                );
              }}
              overlay={popover()}
            >
              <div className="input-group mb-1">
                <input
                  id="dateInput"
                  style={{ cursor: 'pointer', zIndex: 10 }}
                  type="string"
                  className="form-control rounded-start"
                  placeholder={t('date')}
                  aria-label="Publication date"
                  aria-describedby="basic-addon1"
                  autoComplete="off"
                  value={
                    postData?.tempPublicationData.date
                      ? getDateTimeFormated(
                          postData?.tempPublicationData.date,
                          true
                        )
                      : ''
                  }
                  onChange={() => {
                    setToggleDate((prevState) => !prevState);
                  }}
                  onClick={() => {
                    setToggleDate((prevState) => !prevState);
                  }}
                />

                <Button
                  style={{ cursor: 'pointer', zIndex: 1 }}
                  className="input-group-prepend rounded-end p-0 m-0"
                  variant="secondary"
                >
                  <span
                    className="input-group-text rounded-0 rounded-end h-100"
                    id="basic-addon1"
                  >
                    <i className="fa-duotone fa-calendar-days"></i>
                  </span>
                </Button>
              </div>
            </OverlayTrigger>
          </div>
          <div style={{ width: '40%' }} className="d-flex flex-column">
            <label htmlFor="timeInput">{t('time')}</label>
            <div className="input-group mb-1 w-100">
              <TimeSelect
                hour={hour}
                setHour={setHour}
                minute={minute}
                setMinute={setMinute}
                onTimeChange={handleTimeChange}
              />
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-end text-muted">
          <p
            onClick={() => {
              dispatch(
                clearPublicationDateTime({
                  platform
                })
              );
              setCurrentTimeInput(false);
            }}
            style={{ cursor: 'pointer' }}
          >
            {t('lomavisCreator.planningSlide.clear_date')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PublicationDateTimeBox;